import { lazyLoad } from "utils/loadable";

export const AdminAddEditBroadCast = lazyLoad(
  () => import("./index"),
  (module) => module.AdminAddEditBroadCast
);
